import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { Skeleton } from 'shared/ui/Skeleton';

export const CurrentUserSkeleton = () => (
  <Box alignItems='center' display='grid' gridGap={theme.space[4]} gridTemplateColumns='30px auto' width='100%'>
    <Skeleton width='32px' height='32px' />
    <Skeleton fontSize={theme.fontSizes[17]} fontWeight={theme.fontWeights.extraBold} />
  </Box>
);
